module.exports = __webpack_public_path__ + "static/media/BasierCircle-Medium.894dbacf.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Basier Circle/Web/BasierCircle-Medium.woff2
// module id = 6541
// module chunks = 1